module.exports = __webpack_public_path__ + "static/media/acto_de_grado_8.0e5b3e6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/acto_de_grado_8.jpg
// module id = 915
// module chunks = 0